const workerUrl = new URL('./test.worker.js', import.meta.url);

export const SortToArrayCategoryListData = (workerStatic , pureData , cursor , cursorSort ,setWorker, call) => {

  if (workerStatic) {
    workerStatic.terminate();
    workerStatic = new Worker(workerUrl);
    setWorker(workerStatic);
    workerStatic.postMessage({pureData , cursor , cursorSort});
    workerStatic.addEventListener("message", (event) => {
      call(event.data);
    });
  } else {
    workerStatic = new Worker(workerUrl);
    setWorker(workerStatic);
    workerStatic.postMessage({pureData , cursor , cursorSort});
    workerStatic.addEventListener("message", (event) => {
      call(event.data);
    });
  }
};
